import * as React from "react";
import { inject, observer } from "mobx-react";

import { SessionStore, RouterStore } from "@/stores";

import Home from "./Home";

export interface IndexProps {
  session: SessionStore;
  router: RouterStore;
}

@inject("session", "router")
@observer
class Index extends React.Component<IndexProps, any> {
  state = {
    error: null
  };

  componentDidMount() {
    this.getUserInfo();
  }

  getUserInfo = async () => {
    try {
      const { session } = this.props;
      if (!(session.userinfo.email || session.userinfo.mobile)) {
        await session.getUserInfo();
      }
    } catch {}
  };

  render() {
    // if (process.env.NODE_ENV === "development") {
    // }

    const { session } = this.props;
    if (!session.signed) {
      return null;
    }

    return <Home />;
  }
}

export default Index;
